module.exports = __webpack_public_path__ + "media/images/avatar/development/nannies/6-3eee9011ddf59f2f483ba250b6a70a7e.jpg";